/* ************************* */
//
// This file will be made available as /assets/main.js by webpack,
// including *all* imported libraries and networked dependencies here and elsewhere
//
/* ************************* */

// import $ from 'jquery';
// window.jQuery = $;
// window.$ = $;
const _ = require("underscore");
const shared = require("./modules/shared.js");
const dateUtils = require("./modules/date_utils");
const uiUtils = require("./modules/ui_utils");
const clicks = require("./modules/clicks");
const dialogs = require("./modules/dialogs");
const refobjs = require("./modules/refobjs");
const backend = require("./modules/backend");
const media = require("./modules/media");
const tabs = require("./modules/tabs");
// const charts = require('./modules/charts'); // This one struggles with webpack as-is.
const modals = require("@sugarfrontend/modules/modals");
const algolia = require("@sugarfrontend/modules/algolia");

require("./less/sugarwod.less");

_.extend(window, shared); // Temporary hack for migrating to all this newness

const _SugarWOD = {
    constants: {},
};

_SugarWOD.constants.public_api_root = "/public/api/v1";

_SugarWOD.constants.dateFormats = {
    asInteger: "YYYYMMDD",
    timestamp: "dddd, MMM D, h:mm a",
    timestamp_full: "D MMMM YYYY, h:mm a",
    lg: "dddd, MMM D, YYYY",
    xl: "dddd, MMMM D, YYYY",
    md: "MMM D, YYYY",
    sm: "ddd, MMM D",
    sm2: "dddd, MMM D",
    xs: "MMM D",
    csv: "MM/DD/YYYY",
    monthKey: "YYYY-MM",
    monthYear: "MMM YYYY",
};

_SugarWOD.constants.workout_of_the_day = {
    id: "workout-of-the-day",
    display: "Workout of the Day",
};

_SugarWOD.constants.barbell_spec_percent_not_specified = 110;

_SugarWOD.constants.hq = {
    id: "hEvyyT2IQA",
};

// TODO: copied from Athlete.js. might want somewhere else?
_SugarWOD.constants.ATHLETE_GENDERS = {
    NotSpecified: -1,
    Female: 0,
    Male: 1,
};

_SugarWOD.constants.ATHLETE_GENDER_TYPES = {};
_SugarWOD.constants.ATHLETE_GENDER_TYPES[
    _SugarWOD.constants.ATHLETE_GENDERS.NotSpecified
] = {
    id: _SugarWOD.constants.ATHLETE_GENDERS.NotSpecified,
    key: "nospec",
    name: "Not Specified",
    abbreviation: "NS",
    pluralName: "Not Specified",
};
_SugarWOD.constants.ATHLETE_GENDER_TYPES[
    _SugarWOD.constants.ATHLETE_GENDERS.Female
] = {
    id: _SugarWOD.constants.ATHLETE_GENDERS.Female,
    key: "female",
    name: "Female",
    abbreviation: "F",
    pluralName: "Women",
};
_SugarWOD.constants.ATHLETE_GENDER_TYPES[
    _SugarWOD.constants.ATHLETE_GENDERS.Male
] = {
    id: _SugarWOD.constants.ATHLETE_GENDERS.Male,
    key: "male",
    name: "Male",
    abbreviation: "M",
    pluralName: "Men",
};

_SugarWOD.constants.TRACK_TIMELINE_TYPE = {
    Absolute: 0, // default, "normal" date-for-date programming
    Relative: 1, // for progressive programming, cycles, etc
};

_SugarWOD.constants.SUGARWOD_DEFAULT_LEVEL_ID = "dEBJrc3Zb0";

_SugarWOD.constants.SUGARWOD_DEFAULT_PROGRAMMING_LEVELS = [
    {
        id: "dEBJrc3Zb0",
        displayName: "RX/Scaled",
        levels: [
            {
                id: "633b8d23-1b79-4906-a14b-351ebc33d46d",
                displayName: "RX",
                rankValue: 2,
            },
            {
                id: "ce5a80ee-159b-4387-ad0d-267d532e8840",
                displayName: "Scaled",
                rankValue: 1,
            },
        ],
    },
    {
        id: "ErSFQwo0NK",
        displayName: "No Scaling",
        levels: [],
    },
];

_SugarWOD.constants.STANDARD_D_PLAN_ID = "5u3xhEAvyS";
_SugarWOD.constants.STANDARD_E_PLAN_ID = "7sGBk7XqX0";

_.extend(window, dateUtils);
_.extend(window, uiUtils);
_.extend(window, clicks);
_.extend(window, dialogs);
_.extend(window, refobjs);
_.extend(window, backend);
_.extend(window, media);
_.extend(window, tabs);
// _.extend(window,charts);
_.extend(window, modals);
_.extend(window, algolia);
_SugarWOD.session = {
    getAffiliate: function (successFn, errorFn) {
        localforage
            .getItem("cur_aff")
            .then(function (value) {
                if (value) {
                    // if available, return it
                    if (successFn) {
                        successFn(value);
                    }
                } else {
                    // fetch from api
                    _SugarWOD.session.fetchAffiliate(
                        _SugarWOD.session.affId,
                        {},
                        successFn,
                        errorFn
                    );
                }
            })
            .catch(function (err) {
                // we got an error, let caller decide how to handle
                if (errorFn) {
                    errorFn(err);
                } else {
                    // do nothing, fail silently
                }
            });
    },
    saveAffiliate: function (aff, successFn) {
        localforage.setItem("cur_aff", aff);
        if (successFn) {
            successFn(aff);
        }
    },
    flushAffiliate: function (successFn) {
        localforage.removeItem("cur_aff");
        if (successFn) {
            successFn();
        }
    },
    fetchAffiliate: function (affId, params, successFn, errorFn) {
        var callbacks = _SugarWOD.session.fetchAffiliateCallbacks || [];
        callbacks.push(successFn);
        _SugarWOD.session.fetchAffiliateCallbacks = callbacks;

        if (!_SugarWOD.session.isFetching) {
            _SugarWOD.session.isFetching = true;

            var url = "/api/affiliates/" + (affId || "none") + "/session";
            var data = params || {};
            getObjects(
                url,
                data,
                "Fetching affiliate",
                _SugarWOD.session.affiliateFetched,
                errorFn
            );
        }
    },
    affiliateFetched: function (aff) {
        localforage.setItem("cur_aff", aff);
        _SugarWOD.session.isFetching = false;

        var callbacks = _SugarWOD.session.fetchAffiliateCallbacks || [];
        _.each(callbacks, function (callback) {
            callback(aff);
        });
        _SugarWOD.session.fetchAffiliateCallbacks = [];
    },
};
window._SugarWOD = _SugarWOD;
